import { FunctionComponent } from "react";
import '../../assets/styles.css';
import GenericStep from '../GenericStep/GenericStep'
import step8 from '../../assets/img/step8.svg';
import { questions8 } from "../../utils/allData";

interface ContainerProps {
}

const Step8: FunctionComponent<ContainerProps> = (props) => {
    return (
        <GenericStep
            headerImage={step8}
            data={questions8}
            progress={40}
            linkAnterior={"/step7"}
            linkSiguiente={"/step9"}
        ></GenericStep>
    )
}
export default Step8;